/* eslint-disable import/prefer-default-export */
export function getSelectedBranch() {
    if (localStorage && localStorage.branch) {
        return JSON.parse(localStorage.branch);
    }

    return null;
}
